import { render, staticRenderFns } from "./linkNode.vue?vue&type=template&id=35a74d84&scoped=true"
import script from "./linkNode.vue?vue&type=script&lang=js"
export * from "./linkNode.vue?vue&type=script&lang=js"
import style0 from "./linkNode.vue?vue&type=style&index=0&id=35a74d84&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a74d84",
  null
  
)

export default component.exports